import { webApi } from '@mi-front/api-clients';
import { FragmentCardTime } from './FragmentCardTime';
import { FragmentMediaPill } from './FragmentMediaPill';

/**
 * Pill showing fragment start time. Used as overlay on audio/video card media.
 */
export function FragmentCardTimePill({ fragment }: { fragment: webApi.FragmentListItemDto }) {
  return (
    <FragmentMediaPill>
      <FragmentCardTime from={fragment.from} />
    </FragmentMediaPill>
  );
}
